import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./ShopContext";

export const authApi = axios.create({ baseURL: API, withCredentials: true });

export const formatApiError = (detail, fallback = "Si \u00e8 verificato un errore. Riprova.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = guest, object = logged in
  const [user, setUser] = useState(null);

  useEffect(() => {
    authApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await authApi.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (name, email, password, lang = "it") => {
    const { data } = await authApi.post("/auth/register", { name, email, password, lang });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await authApi.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
